
import { computed, defineComponent, PropType } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'

// @types
import { DispatcherSector } from '@/new-services/types/dispatcher-sectors'

export default defineComponent({
    name: 'new-extended-sector-form',
    components: {
        NewButton,
    },
    props: {
        isCreate: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        dispatcherSector: {
            type: Object as PropType<DispatcherSector>,
            default: null,
        },
        isPaintStarted: {
            type: Boolean,
            default: false,
        },
        isSectorAdded: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'create', 'update'],
    setup(props, { emit }) {
        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const onCreate = async () => {
            if (props.loading) return
            emit('create', { dispatcherSector: props.dispatcherSector })
        }

        const onUpdate = async () => {
            if (props.loading) return
            emit('update', { dispatcherSector: props.dispatcherSector })
        }

        const modalTitle = computed(() => {
            if (props.isCreate) {
                return 'Добавление внешнего сектора'
            }

            if (props.isUpdate) {
                return 'Редактирование внешнего сектора'
            }

            return 'modal title'
        })

        return {
            onCancel,
            onCreate,
            onUpdate,
            modalTitle,
        }
    },
})
